import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild, TemplateRef } from '@angular/core';
import { DataTableColumn } from '../../../shared/ui/data-table/data-table.component';
import { ManagerService, SellerService, FileService } from '../../../core';
import { PopupMessageService } from '../../../shared/message/services/message.service';
import { managerApi } from '../../../config';

@Component({
  selector: 'app-download-file-modal',
  templateUrl: './download-file-modal.component.html',
  styleUrls: ['./download-file-modal.component.scss']
})
export class DownloadFileModalComponent implements OnChanges {
  @Input() triggerChallenge: any = null;
  @Output() closed = new EventEmitter<void>();

  @ViewChild('dfCategoryTpl') dfCategoryTpl!: TemplateRef<any>;
  @ViewChild('dfRegionTpl') dfRegionTpl!: TemplateRef<any>;
  @ViewChild('dfFilenameTpl') dfFilenameTpl!: TemplateRef<any>;
  @ViewChild('dfGenerateTpl') dfGenerateTpl!: TemplateRef<any>;
  @ViewChild('dfUploadTpl') dfUploadTpl!: TemplateRef<any>;

  isModalOpen = false;
  dfData: any = null;
  dfMode: string | null = null;
  dfSelectedCategory: string = '';
  dfCategoryItem: any = null;
  dfColumns: DataTableColumn[] = [];
  dfRegionList: any[] = [];
  dfUploadSubmitBtn: boolean = true;
  dfLoading: string | null = null;
  categoryList: any[] = [];

  get dfFilteredRows(): any[] {
    return this.dfRegionList.filter((item: any) => item.category === this.dfSelectedCategory);
  }

  constructor(
    private managerService: ManagerService,
    private sellerService: SellerService,
    private fileService: FileService,
    private popupMessageService: PopupMessageService
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['triggerChallenge'] && changes['triggerChallenge'].currentValue) {
      this.loadAndOpen(changes['triggerChallenge'].currentValue);
    }
  }

  private loadAndOpen(val: any) {
    const data = val.data;
    const mode = val.mode;
    const categories = val.categories;
    const countryGroupList = val.countryGroupList;
    this.dfData = data;
    this.dfMode = mode;
    this.categoryList = categories.uploadFileCategoryList;
    const list = this.categoryList;
    if (data.attachedFiles.length === 0) {
      this.dfCategoryItem = list[0];
    } else {
      const firstCat = data.attachedFiles[0].category;
      const found = list.find((x: any) => x.value === firstCat);
      this.dfCategoryItem = found ? found : list[0];
    }
    this.dfSelectedCategory = this.dfCategoryItem.value;
    this.dfRegionList = this.buildDfRegionList(list, data.regions, countryGroupList, data);
    this.dfMatchAttachedFiles();
    this.isModalOpen = true;
    setTimeout(() => { this.buildDfColumns(); });
  }

  closeModal() {
    this.isModalOpen = false;
    this.dfData = null;
    this.dfMode = null;
    this.dfCategoryItem = null;
    this.dfColumns = [];
    this.dfRegionList = [];
    this.dfUploadSubmitBtn = true;
    this.dfLoading = null;
    this.closed.emit();
  }

  onDfCategoryChange(item: any) {
    this.dfCategoryItem = item;
    this.dfSelectedCategory = item.value;
    this.buildDfColumns();
  }

  dfGetFile(eve: any, item: any) {
    item.data = eve.target.files[0];
    item.showUploadBtn = true;
    item.uploadSuccess = false;
    item.flag = false;
  }

  dfRemoveFile(item: any) {
    item.data = '';
    item.showUploadBtn = false;
    item.flag = true;
    item.uploadSuccess = false;
    item.uploadFailure = false;
  }

  dfDownloadFile(item: any) {
    window.open(item.data.url, '_blank');
  }

  dfUploadFile(item: any) {
    item.isUploading = true;
    const uploadData = new FormData();
    uploadData.append('file-to-be-uploaded', item.data);
    const challengeId = item.id;
    let param = '?CustomChallengeId=' + challengeId + '&region=' + item.region + '&category=' + this.dfSelectedCategory;
    if (item.countryGroupId) {
      param = param + '&countryGroupId=' + item.countryGroupId;
    }
    this.sellerService.uploadAttachedDocument(uploadData, param).subscribe(
      (data: any) => {
        if (data.message) {
          item.flag = true;
          item.showUploadBtn = false;
          item.uploadSuccess = true;
          item.uploadFailure = false;
          item.name = item.data.name;
          item.data = '';
          item.isUploading = false;
          if (this.dfSelectedCategory === 'TERMS_AND_CONDITIONS') {
            const uploaded = this.dfRegionList.filter((x: any) => x.category === 'TERMS_AND_CONDITIONS');
            if (uploaded.find((x: any) => x.flag === false)) {
              this.dfUploadSubmitBtn = true;
            } else {
              this.dfUploadSubmitBtn = false;
            }
          }
        }
      },
      () => {
        this.dfUploadSubmitBtn = true;
        item.flag = false;
        item.showUploadBtn = true;
        item.uploadSuccess = false;
        item.uploadFailure = true;
        item.isUploading = false;
      }
    );
  }

  dfGenerateFile(list: any) {
    this.dfLoading = list.key;
    const id = list.id;
    let req = 'customChallengeId=' + id + '&region=' + list.region;
    if (list.countryGroupId) {
      req = req + '&countryGroupId=' + list.countryGroupId;
    }
    let url = '';
    if (list.category === 'TERMS_AND_CONDITIONS') {
      url = managerApi.generateTandConditionsFile + req;
    } else if (list.category === 'ELIGIBLE_PRODUCT_LIST') {
      url = managerApi.generateEligProductsDocumentationAsDownloadable + req;
    }
    this.fileService.downloadFile(url).subscribe(
      () => { this.dfLoading = null; },
      () => { this.dfLoading = null; }
    );
  }

  dfSubmitUploadTerms() {
    this.dfUploadSubmitBtn = true;
    const params = 'id=' + this.dfData.id + '&status=PENDING_FINAL_APPROVAL';
    this.managerService.submitForApproval(params).subscribe(
      (data: any) => {
        if (data !== '') {
          this.dfUploadSubmitBtn = false;
          this.popupMessageService.showSuccess(
            'Uploaded Terms and condition successfully',
            'success',
            'salesChallengeToggleForm'
          );
          this.closeModal();
        }
      },
      () => {}
    );
  }

  private buildDfColumns() {
    const isUpload = this.dfMode === 'uploadDocument';
    const cols: DataTableColumn[] = [
      { field: 'category', header: 'Category', cellTemplate: this.dfCategoryTpl },
      { field: 'region', header: 'Region / Country Group', cellTemplate: this.dfRegionTpl },
      { field: 'filename', header: 'File Name', cellTemplate: this.dfFilenameTpl },
    ];
    if (isUpload && this.dfSelectedCategory !== 'OTHERS') {
      cols.push({ field: 'generate', header: 'Generate File', cellTemplate: this.dfGenerateTpl });
    }
    if (isUpload) {
      cols.push({ field: 'upload', header: 'Upload File', cellTemplate: this.dfUploadTpl });
    }
    this.dfColumns = cols;
  }

  private dfMatchAttachedFiles() {
    const attachedFiles = this.dfData ? this.dfData.attachedFiles : [];
    this.dfRegionList.forEach((region: any) => {
      let matched = false;
      for (const attachedFile of attachedFiles) {
        if (attachedFile.category !== region.category) {
          continue;
        }
        if (attachedFile.countryGroup && attachedFile.countryGroup.id === region.countryGroupId) {
          region.name = attachedFile.name;
          region.noAttachment = false;
          region.data = { url: attachedFile.url };
          matched = true;
          break;
        }
        if (!matched && !region.countryGroupId && attachedFile.region === region.region) {
          region.name = attachedFile.name;
          region.noAttachment = false;
          region.data = { url: attachedFile.url };
          matched = true;
        }
      }
      if (!matched) {
        region.name = 'File Not Found';
        region.noAttachment = true;
        region.data = null;
      }
    });
  }

  private buildDfRegionList(categories: any[], regions: any[], countryGroupList: any, data: any): any[] {
    const regionList: any[] = [];
    const targetDate = new Date('2025-10-25');
    categories.forEach((category: any) => {
      regions.forEach((region: any) => {
        const normalizedDateStr = data.startDate.replace(/\+0000$/, 'Z');
        const startDate = new Date(normalizedDateStr);
        const hasCountryGroups = startDate > targetDate && Array.isArray(countryGroupList[region]) && countryGroupList[region].length > 0;
        if (hasCountryGroups) {
          countryGroupList[region].forEach((countryGroup: any) => {
            regionList.push({
              key: region + countryGroup.id,
              id: data.id,
              region: region,
              countryGroupId: countryGroup.id,
              countryGroupName: countryGroup.name,
              category: category.value,
              data: '',
              flag: false,
              showUploadBtn: false,
            });
          });
        } else {
          regionList.push({
            key: region,
            id: data.id,
            region: region,
            category: category.value,
            data: '',
            flag: false,
            showUploadBtn: false,
            name: '',
          });
        }
      });
    });
    return regionList;
  }
}
